module.exports = __webpack_public_path__ + "assets/img/bd82-eh.svg";